import { takeEvery, fork, put, all, call } from "redux-saga/effects"

// Login Redux States
import {
  EDIT_PROFILE,
  UPDATE_PASSWORD,
  UPDATE_PHONE_NUMBER,
  UPDATE_USER_DETAILS,
  UPDATE_USER_PROFILE_PICTURE,
  UPDATE_TWO_FACTOR_AUTH, UPDATE_ORG_LOGO
} from "./actionTypes"

import {
  profileSuccess,
  profileError,
  updateUserProfilePictureSuccess,
  updateUserProfilePictureError,
  updateTwoFactorAuthSuccess,
  updateTwoFactorAuthError, updateOrgLogo, updateOrgLogoSuccess, updateOrgLogoFail
} from "./actions"

//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper"
import {
  UpdatePhoneNumber,
  postFakeProfile,
  postJwtProfile,
  updatePassword,
  UpdateUserDetails,
  postUpdateProfilePicture,
  postUpdateTwoFactorAuth, updateOrgLogoUrl
} from "../../../helpers/fakebackend_helper"
import { showNotification } from "components/Common/notification"

const fireBaseBackend = getFirebaseBackend()

function* editProfile({ payload: { user } }) {
  try {
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = yield call(
        fireBaseBackend.editProfileAPI,
        user.username,
        user.idx
      )
      yield put(profileSuccess(response))      
    } else if (process.env.REACT_APP_DEFAULTAUTH === "jwt") {
      const response = yield call(postJwtProfile, "/post-jwt-profile", {
        username: user.username,
        idx: user.idx,
      })
      yield put(profileSuccess(response))
    } else if (process.env.REACT_APP_DEFAULTAUTH === "fake") {
      const response = yield call(postFakeProfile, {
        username: user.username,
        idx: user.idx,
      })
      yield put(profileSuccess(response))
    }
  } catch (error) {
    yield put(profileError(error))
  }
}

function* onUpdatePassword({ payload: { data } }){
  try{
    const response = yield call(updatePassword, data);
    if (response) {
      showNotification("success", response.message);
    }
  } catch(error){
    showNotification("error", error.response.data.message);
  }
}
function* OnUpdatePhoneNumber({payload: { phone_number }}){
  try {
    const response = yield call(UpdatePhoneNumber, {phone_number});
    if (response) {
    showNotification("success", response.message);
    yield  put(profileSuccess(response.message));
    }
  } catch (error) {
    showNotification("error", error.response.data.message);
  }
}

function* OnUpdateUserDetails({payload: { name, phone_number }}){
  try {
    const response = yield call(UpdateUserDetails, {name, phone_number});
    if (response) {
    showNotification("success", "Name updated successfully!");
    yield put(profileSuccess(response.message));
    }
  } catch (error) {
    showNotification("error", error.response.data.message);
  }
}

function* updateUserProfilePicture({ payload: { data } }) {
    try {
        const response = yield call(postUpdateProfilePicture, data);
        yield put(updateUserProfilePictureSuccess(response));
        showNotification("success", "Profile picture updated successfully!");

        // Wait for sometime and reload the page
        setTimeout(() => {
            window.location.reload();
        }, 3000);

    } catch (error) {
        yield put(updateUserProfilePictureError(error));
    }
}

function* updateTwoFactorAuth({ payload: { data } }) {
    try {
        const response = yield call(postUpdateTwoFactorAuth, data);
        yield put(updateTwoFactorAuthSuccess(response));
        showNotification("success", response.message);
    } catch (error) {
        yield put(updateTwoFactorAuthError(error));
    }
}

function* onUpdateOrgLogo({ payload: { data } }) {
  try {
    const response = yield call(updateOrgLogoUrl, data);
    yield put(updateOrgLogoSuccess(response));
    showNotification("success", response.message);
  }catch(error) {
    yield put(updateOrgLogoFail(error));
  }
}

export function* watchProfile() {
  yield takeEvery(EDIT_PROFILE, editProfile)
  yield takeEvery(UPDATE_PASSWORD, onUpdatePassword)
  yield takeEvery(UPDATE_PHONE_NUMBER, OnUpdatePhoneNumber)
  yield takeEvery(UPDATE_USER_DETAILS, OnUpdateUserDetails);
  yield takeEvery(UPDATE_USER_PROFILE_PICTURE, updateUserProfilePicture)
  yield takeEvery(UPDATE_TWO_FACTOR_AUTH, updateTwoFactorAuth)
  yield takeEvery(UPDATE_ORG_LOGO,onUpdateOrgLogo);
}

function* ProfileSaga() {
  yield all([fork(watchProfile)])
}

export default ProfileSaga
